window.LoopConfig = {
  DIGITAL_OCEAN_BASE_URL: "https://services.barkyn.com/v0",

  // Dogs API (core-api). baseUrl overrides the automatic production/staging
  // pick in barkyn-dogs-api.js — leave null outside of testing.
  dogsApi: {
    baseUrl: null,
  },

  drawerTweaks: [
    {
      selector:
        "#loop-upsell-drawer-body .loop-card-body .d-flex .d-flex.flex-column.justify-content-between .loop-text-p1",
      add: ["line-height-normal"],
      remove: ["loop-text-p1"],
    },
    {
      selector:
        "#loop-upsell-drawer-body .loop-card-body .d-flex .d-flex.flex-column.justify-content-between .d-flex.justify-content-between .loop-text-p2",
      add: ["line-height-normal"],
      remove: ["loop-text-p2", "loop-text-muted"],
    },
    {
      selector:
        "#loop-upsell-drawer-body .loop-card-body .d-flex .d-flex.flex-column.justify-content-between .d-flex.justify-content-between",
      add: ["align-items-center"],
      remove: [],
    },
    {
      selector:
        "#loop-cp-drawer-id-add-product .loop-drawer-content .loop-drawer-body .mx-2 .w-100",
      add: ["justify-content-center"],
      remove: ["justify-content-start"],
    },
    {
      selector:
        "#loop-cp-drawer-id-add-product .loop-drawer-footer .d-flex.flex-column .loop-btn-size-lg",
      add: ["justify-content-center", "upsell-drawer-primary-btn"],
      remove: [],
    },
    {
      selector:
        "#loop-cp-drawer-id-add-product .loop-drawer-body .mx-2 .d-flex.flex-column.align-items-start",
      add: ["align-items-center", "gap-2"],
      remove: ["align-items-start"],
    },
    {
      selector:
        "#loop-cp-drawer-id-add-product .loop-drawer-body .mx-2 .d-flex.flex-column .w-100.my-2 .mb-2.mt-3",
      add: ["w-100"],
      remove: [],
    },
  ],
};
